import { Component, Input, OnInit, OnChanges, Inject, AfterViewInit, ViewChild, ElementRef, HostListener } from "@angular/core";
import { faPlus } from "@fortawesome/pro-light-svg-icons";
import { ControlContainer, FormGroupDirective } from "@angular/forms";
import { DOCUMENT } from "@angular/common";
import { CanvasService } from "@services/canvas.service";
import { CommonService } from "@services/common.service";
import { Router } from "@angular/router";
import { ROUTE_URL } from "../../constants/routes";
@Component({
    selector: "app-related-bar",
    templateUrl: "./related-bar.component.html",
    styleUrls: ["./related-bar.component.scss"],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
    standalone: false
})
export class RelatedBarComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  showLeftArrow: boolean = false;
  showRightArrow: boolean = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private canvasService: CanvasService,
    private commonService: CommonService,
    public parentF: FormGroupDirective,
    private router: Router
  ) {}
  @Input() hasEdit?: any;
  @Input() canvasId?: any;
  @Input() module_id?: any;

  public categories: any[] = [];
  faPlus = faPlus;

  savedData!: any[];
  childForm: any;
  relatedDashboards: any[] = [];

  ngOnInit() {
    this.childForm = this.parentF.form;
    if (this.module_id) {
      this.getRelatedDashboards();
      this.getCategories();
    }
  }

  ngOnChanges() {
    this.childForm = this.parentF.form;
    if (this.module_id) {
      this.getRelatedDashboards();
    }
  }

  ngAfterViewInit() {
    this.checkOverflow();
  }

  @HostListener('window:resize')
  onResize() {
    this.checkOverflow();
  }

  getRelatedDashboards() {
    const category: any = this.childForm.get("module_id")!.value || this.module_id;
    this.canvasService.getRelatedDashboards(category).subscribe((data: any) => {
      this.relatedDashboards = data.data;
      setTimeout(() => this.checkOverflow(), 0);
    });
  }

  gotoDashboard(id: any) {
    this.router.navigate([ROUTE_URL.viewDashboardAppURL, id]);
  }

  showRelatedBar() {
    return this.hasEdit && this.relatedDashboards.length > 0;
  }

  getCategory(id: number) {
    let selected = this.categories.find((module: any) => module.id == id);
    return selected ? selected.brandIconUrl : "";
  }

  getCategories() {
    this.commonService.getAllCategories().subscribe((data: any) => {
      this.categories = data.data;
    });
  }

  checkOverflow() {
    const container = this.scrollContainer?.nativeElement;
    if (container) {
      this.showLeftArrow = container.scrollLeft > 0;
      this.showRightArrow = container.scrollWidth > container.clientWidth;
    }
  }
  scrollLeft() {
    if (this.scrollContainer) {
      this.scrollContainer.nativeElement.scrollBy({ left: -150, behavior: 'smooth' });
      setTimeout(() => this.checkOverflow(), 300);
    }
  }

  scrollRight() {
    if (this.scrollContainer) {
      this.scrollContainer.nativeElement.scrollBy({ left: 150, behavior: 'smooth' });
      setTimeout(() => this.checkOverflow(), 300);
    }
  }
}
